const elementNodeNames: string[] = ["B", "STRONG", "I", "U", "EM", "MARK", "SUB", "SUP", "INS", "PRE", "ABBR"];
const blockElements = ["P", "H1", "H2", "H3", "H4", "H5", "H6", "LI", "BLOCKQUOTE", "DT", "DD", "DIV", "SECTION", "ARTICLE", "ASIDE"];

/**
 * Gets the full sentence context for a given element, including adjacent text nodes
 * and inline elements to provide a natural reading experience.
 */
export function getFullSentence(node: HTMLElement): string {
  if (!node) {
    return '';
  }

  // Handle images and svgs separately
  if (node.nodeName === 'IMG') {
    return (node as HTMLImageElement).alt || (node as HTMLImageElement).title || 'Image';
  }

  if (node.nodeName === 'SVG') {
    return node.getAttribute('aria-label') || node.querySelector('title')?.textContent || 'Graphic';
  }

  // If it's a block element or a container, we usually want to read its entire inner content
  const isBlock = blockElements.includes(node.nodeName);

  if (isBlock) {
    return node.innerText?.trim().replace(/[ \n]+/g, ' ') || '';
  }

  let sentence = '';
  let prevNode: Node | null = node.previousSibling;
  let nextNode: Node | null = node.nextSibling;

  // Walk backwards to find start of "sentence" context for inline elements
  while (prevNode) {
    if (
      prevNode.nodeType === Node.TEXT_NODE ||
      elementNodeNames.includes(prevNode.nodeName)
    ) {
      const textContent = prevNode.textContent?.trim().replace(/[ \n]+/g, ' ');
      if (textContent) {
        sentence = textContent + ' ' + sentence;
      }
    } else {
      break;
    }

    prevNode = prevNode.previousSibling;
  }

  sentence += node.innerText?.trim().replace(/[ \n]+/g, ' ') || node.textContent?.trim().replace(/[ \n]+/g, ' ') || '';

  // Walk forwards to find end of "sentence" context for inline elements
  while (nextNode) {
    if (
      nextNode.nodeType === Node.TEXT_NODE ||
      elementNodeNames.includes(nextNode.nodeName)
    ) {
      const textContent = nextNode.textContent?.trim().replace(/[ \n]+/g, ' ');
      if (textContent) {
        sentence += ' ' + textContent;
      }
    } else {
      break;
    }

    nextNode = nextNode.nextSibling;
  }

  return sentence.trim();
}

/**
 * Scrolls to an element and highlights it temporarily.
 */
export function scrollToElement(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const originalOutline = el.style.outline;
    const originalTransition = el.style.transition;

    el.style.transition = 'outline 0.2s ease';
    el.style.outline = '4px solid #0848ca';
    el.style.outlineOffset = '2px';

    setTimeout(() => {
        el.style.outline = originalOutline;
        setTimeout(() => {
            el.style.transition = originalTransition;
        }, 200);
    }, 2000);
}
